import ZendeskLink from "./ZendeskLink";

export default function ForMoreInfoZendeskLink({ message, url }) {
    const instructions = message || "For more information";
    return <>
        <> {instructions}</> <ZendeskLink url={url}>click here.</ZendeskLink>
    </>
}
